import React from 'react';

import InvoicesMobileNavigation from './InvoicesMobileNavigation';
import InvoicesDesktopNavigation from './InvoicesNavigation';
import { useIsSmall } from '../../../../Components/Context/Hooks/mediaQueries';
import { BoxProps } from '../../../../Components/UI/Box';

const InvoicesNavigation: React.FC<BoxProps> = (props) => {
  const isSmall = useIsSmall();
  return isSmall ? <InvoicesMobileNavigation {...props} /> : <InvoicesDesktopNavigation {...props} />;
};

export default InvoicesNavigation;
